module.exports = {
  siteurl: 'https://tour-cms.mauritshuis.nl'
};